import fornecedoresMenu from './fornecedores/menu'
import gestoresMenu from './gestores/menu'
import gerentesMenu from './gerentes/menu'
import financeiroMenu from './financeiro/menu'
import apoiosMenu from './apoios/menu'
import uabsMenu from './uabs/menu'
import adminMenu from './admin/menu'


export default {
    name: 'SGTEC',
    url: '/sgtec',
    icon: 'fa fa-users',
    regras: [
        ...fornecedoresMenu.map(r => r.regras),
        ...gestoresMenu.map(r => r.regras),
        ...gerentesMenu.map(r => r.regras),
        ...financeiroMenu.map(r => r.regras),
        ...uabsMenu.map(r => r.regras),
        ...apoiosMenu.map(r => r.regras),
        ...adminMenu.map(r => r.regras),
       
    ],
    children: [...fornecedoresMenu, ...gestoresMenu, ...gerentesMenu, ...financeiroMenu, ...uabsMenu, ...apoiosMenu, ...adminMenu]
}
